import AppLayout from '@components/layouts/appLayout';
import { Message } from '@hello-pimster/pimster-crm-sdk';
import { useElementSize } from '@hooks/useElementSize';

import { ChatAvatar } from './ChatAvatar';
import ChatFooter from './ChatFooter';
import ChatHeader from './ChatHeader';
import ChatMessageList from './ChatMessageList';
import { useChat } from '../hooks/useChat';



interface ChatProps {
    agentId: number;
    locale: string;
    name: string;
    assistantAvatar: ChatAvatar;
    initialMessage: Message;
    initialInput?: string;
}

export const Chat = ({
    agentId,
    locale,
    name,
    assistantAvatar,
    initialMessage,
    initialInput,
}: ChatProps) => {
    const { input, messages, handleInputChange, handleSubmit } = useChat({
        agentId,
        locale,
        initialMessage,
        initialInput,
    });
    const [layoutSize, layoutRef] = useElementSize();
    const [headerSize, headerRef] = useElementSize();
    const [footerSize, footerRef] = useElementSize();

    return (
        <AppLayout
            ref={layoutRef}
            header={<ChatHeader title={name} ref={headerRef} />}
            body={
                <ChatMessageList
                    messages={messages}
                    assistantAvatar={assistantAvatar}
                    // To help build the auto scroll to bottom
                    layoutHeight={layoutSize.clientHeight}
                    headerHeight={headerSize.clientHeight}
                    footerHeight={footerSize.clientHeight}
                />
            }
            footer={
                <ChatFooter
                    input={input}
                    ref={footerRef}
                    handleInputChange={handleInputChange}
                    handleSubmit={handleSubmit}
                />
            }
            hasFixedFooter
        />
    );
};
